<template>
  <div class>
    <el-dialog :title="title" :visible.sync="dialogFormVisible" width="800px" :close-on-click-modal="false" @close="close">
      <el-form ref="form" :model="form" label-width="180px">
        <el-form-item label="商户名称" prop="storeName" :required="true">
          <el-input v-model.trim="form.storeName" autocomplete="off" placeholder="请输入商户名称"></el-input>
        </el-form-item>
        <el-form-item label="联系人" prop="userName" :required="true">
          <el-input v-model.trim="form.userName" autocomplete="off" placeholder="请输入联系人"></el-input>
        </el-form-item>
        <el-form-item label="联系方式" prop="tel" :required="true">
          <el-input v-model.trim="form.tel" autocomplete="off" placeholder="请输入联系方式"></el-input>
        </el-form-item>
        <el-form-item label="所属区域" prop="cityArr" :required="true">
          <el-cascader v-model="form.cityArr" :options="data" size="medium" @change="cascaderChange" filterable></el-cascader>
        </el-form-item>
        <el-form-item label="商家详细地址" :required="true" prop="address">
          <el-input placeholder="请输入商家地址" v-model="form.address" style="width: 400px">
            <!-- <el-button slot="append" @click="searchMapClick">搜索</el-button> -->
          </el-input>
        </el-form-item>
        <!-- <el-form-item label="店铺经纬度" :required="true">
          <el-input v-model="form.lng" type="number" disabled style="width: 130px" class></el-input>
          <el-input v-model="form.lat" disabled type="number" style="width: 130px" class="mar_l20"></el-input>
        </el-form-item> -->
        <!-- <el-form-item label="地图定位" :required="true">
          <div>
            <select-map ref="mapCom" :mapLng="form.lng" :mapLat="form.lat" :mapAddress="form.address" @clickmap="getMapdata"></select-map>
          </div>
        </el-form-item> -->
        <el-form-item label="营业执照" prop="media" :required="true">
          <custom-upload v-model="form.media"></custom-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="medium" @click="close">{{ $t('common.cancel') }}</el-button>
        <el-button size="medium" type="primary" @click="save">{{ $t('common.confirm') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getCity, addStore, getStoreInfo, getLocation } from '@/api/store';
import attachmentImg from '@/plugins/attachment-img';
import selectMap from '@/plugins/selectmap';
import customUpload from '@/components/custom-upload.vue';
// import selectMapt from "@/plugins/selectmapt";
export default {
  name: 'labelSave',
  components: { attachmentImg, selectMap, customUpload },
  data() {
    return {
      form: {
        id: '',
        storeName: '',
        userName: '',
        tel: '',
        cityArr: [],
        address: '',
        media: '',
        rule: '',
        lng: 0,
        lat: 0
      },
      data: [], //商家区域
      options2: [
        {
          value: '0',
          label: '全部'
        },
        {
          value: '1',
          label: '外卖商家'
        },
        {
          value: '2',
          label: '跑腿商家'
        }
      ],
      title: '',
      dialogFormVisible: false
    };
  },
  created() {
    this.getCity();
    this.getLocation();
  },
  methods: {
    async getCity() {
      const { data } = await getCity();
      this.data = data;
    },
    async getLocation() {
      const { data } = await getLocation();
      this.form.lat = Number(data.lat);
      this.form.lng = Number(data.lng);
      this.form.address = data.address;
    },
    showEdit(row) {
      if (!row) {
        this.title = '添加';
      } else {
        this.title = '编辑';
        this.getStoreInfo(row.id);
      }
      this.dialogFormVisible = true;
    },
    close() {
      this.$refs['form'].resetFields();
      this.form = this.$options.data().form;
      this.dialogFormVisible = false;
    },
    cascaderChange(e) {
      this.form.cityArr = e;
    },
    async getStoreInfo(id) {
      const { data } = await getStoreInfo({ id: id });
      this.form.storeName = data.storeName;
      this.form.userName = data.userName;
      this.form.address = data.address;
      this.form.cityArr = [String(data.cityArr[0]), String(data.cityArr[1]), String(data.cityArr[2])];

      this.form.media = data.media;
      this.form.lng = Number(data.lng);
      this.form.lat = Number(data.lat);
      this.form.tel = data.tel;
      this.form.rule = String(data.rule);
      this.form.id = data.id;
    },
    //图片
    enter(i = 0) {
      this.$refs['imgicon' + i].style.display = 'none';
    },
    leave(i = 0) {
      this.$refs['imgicon' + i].style.display = 'inline-block';
    },
    test(i = 0) {
      console.log(this.$refs, i);
      this.$refs['img' + i].dialogVisible = true;
    },
    imgadd1(url) {
      this.form.media = url.str;
    },
    deleteMultiImage(item, index, type) {
      //typem没传是单图multigraph多图；index上传图片组件排序
      Array.prototype.remove = function (val) {
        var index = this.indexOf(val);
        if (index > -1) {
          this.splice(index, 1);
        }
      };
      if (!type) {
        switch (index) {
          case 1:
            this.form.media = '';
            break;
        }
      }
    },
    getMapdata(mapAddress, mapLat, mapLng) {
      this.form.address = mapAddress;
      this.form.lat = mapLat;
      this.form.lng = mapLng;
    },
    searchMapClick() {
      // console.log(this.$refs.mapCom); //返回的是一个vue对象，所以可以直接调用其方法
      // this.$refs.mapCom.searchKeyword();
    },
    save() {
      this.$refs['form'].validate(async (valid) => {
        if (valid) {
          const { msg } = await addStore(this.form);
          this.$baseMessage(msg, 'success');
          this.$emit('fetchData');
          this.close();
        } else {
          return false;
        }
      });
    }
  }
};
</script>
